import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  forms: [],
  formCount: 0,
  currentForm: null,
  submissions: [],
  submissionCount: 0,
  analytics: null,
};

const formsSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    forms: (state, action) => {
      state.forms = action.payload.records || [];
      state.formCount = action.payload.count || 0;
    },
    currentForm: (state, action) => {
      state.currentForm = action.payload;
    },
    submissions: (state, action) => {
      state.submissions = action.payload.records || [];
      state.submissionCount = action.payload.count || 0;
    },
    analytics: (state, action) => {
      state.analytics = action.payload;
    },
  },
});

export const { forms, currentForm, submissions, analytics } = formsSlice.actions;
export default formsSlice.reducer;
